// test148
(148 && 0);
